export default {
  path: '/sokningar',
  component: () => import('@/views/searchLogs/SearchLogsHome.vue'),
  children: [
    {
      path: '',
      name: 'SearchLogs',
      component: () => import('@/views/searchLogs/Home.vue'),
      children: [
        {
          path: 'export',
          name: 'SearchLogsExport',
          component: () => import('@/views/searchLogs/SearchLogsExport.vue'),
        },
      ],
    },
  ],
}
